import render from './bootstrapper';

export default render;
